import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import HeroSlider from "./components/HeroSlider";
import PhotoCategories from "./components/PhotoCategories";
import CategoryGrid from "./components/CategoryGrid";
import FeatureBanner from "./components/FeatureBanner";
import SpecialOrderAndFooter from "./components/SpecialOrderAndFooter";
import SideMenu from "./components/SideMenu";
import MenuModal from "./components/MenuModal";
import ProductDetailModal from "./components/ProductDetailModal";
import DatenschutzModal from "./components/DatenschutzModal";
import BottomNav from "./components/BottomNav";
import "./assets/styles/App.css";
import { getCategories } from "./api/category-service";
import { getProductWithCatId } from "./api/product-service";

export default function App() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isSideOpen, setIsSideOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [productsLoading, setProductsLoading] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDatenschutzOpen, setIsDatenschutzOpen] = useState(false);

  // 1. Kategorileri Çek
  useEffect(() => {
    getCategories()
      .then((res) => {
        // Axios veriyi doğrudan res.data içinde sunar
        const data = res.data;

        const formattedCategories = data.map((cat) => ({
          id: cat._id,
          title: cat.title,
          catGroup: cat.cat,
          image: cat.img,
          items: [],
        }));

        setCategories(formattedCategories);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Kategori çekme hatası:", err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // 2. Kategoriye tıklandığında ürünleri çek ve Portion / Kg fiyatlarını ayarla
  const handleSelectCategory = (cat) => {
    setSelectedCategory({ ...cat, items: [] });
    setProductsLoading(true);

    getProductWithCatId(cat.id)
      .then((res) => {
        // Axios veriyi doğrudan res.data içinde sunar
        const data = res.data;

        const formattedProducts = data.map((prod) => {
          let kgPrice = prod.price ? `${prod.price} €` : null;
          let portionPrice = null;

          if (prod.sizeOptions && prod.sizeOptions.length > 0) {
            const portionOption = prod.sizeOptions.find(
              (opt) => opt.text?.toLowerCase().includes("portion") || opt.price,
            );

            if (portionOption && portionOption.price) {
              portionPrice = `${portionOption.price} €`;
            } else {
              portionPrice = prod.price
                ? `${(prod.price / 4).toFixed(2)} €`
                : null;
            }
          } else if (prod.price) {
            portionPrice = `${(prod.price / 4).toFixed(2)} €`;
          }

          return {
            id: prod._id,
            title: prod.title,
            description: prod.desc || "",
            image: prod.img,
            kgPrice: kgPrice,
            portionPrice: portionPrice,
            sizeOptions: prod.sizeOptions || [],
            modelOptions: prod.modelOptions || [],
            tasteOptions: prod.tasteOptions || [],
          };
        });

        setSelectedCategory({
          ...cat,
          items: formattedProducts,
        });
        setProductsLoading(false);
      })
      .catch((err) => {
        console.error("Ürün çekme hatası:", err);
        setProductsLoading(false);
      });
  };

  const scrollToCategories = () => {
    const el = document.getElementById("kategorien");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="app">
      <Header onOpenSideMenu={() => setIsSideOpen(true)} />

      <HeroSlider onScrollToCategories={scrollToCategories} />

      {loading ? (
        <div
          style={{
            textAlign: "center",
            padding: "50px 20px",
            color: "var(--green)",
            fontWeight: "bold",
          }}
        >
          Kategorien werden geladen...
        </div>
      ) : error ? (
        <div
          style={{
            textAlign: "center",
            padding: "50px 20px",
            color: "#d9534f",
          }}
        >
          Verbindung zum Server fehlgeschlagen.
        </div>
      ) : (
        <>
          {/* Highlights (Sadece 3 Kategori) */}
          <PhotoCategories
            categories={categories}
            onSelectCategory={handleSelectCategory}
          />

          {/* Tüm Kategoriler Grid Yapısı */}
          <CategoryGrid
            categories={categories}
            onSelectCategory={handleSelectCategory}
          />
        </>
      )}

      <FeatureBanner
        onOpenCategory={() => {
          if (categories.length > 0) handleSelectCategory(categories[0]);
        }}
      />

      <SpecialOrderAndFooter
        onOpenDatenschutz={() => setIsDatenschutzOpen(true)}
      />

      <SideMenu
        isOpen={isSideOpen}
        onClose={() => setIsSideOpen(false)}
        categories={categories}
        onSelectCategory={handleSelectCategory}
        onOpenDatenschutz={() => setIsDatenschutzOpen(true)}
      />

      {/* Kategori Modalı (Portion & Kg Fiyatlı) */}
      <MenuModal
        category={selectedCategory}
        isLoading={productsLoading}
        onClose={() => setSelectedCategory(null)}
        onSelectProduct={(prod) => setSelectedProduct(prod)}
      />

      {/* Ürün Detay Modalı */}
      <ProductDetailModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
      />

      {/* Datenschutz Modalı */}
      <DatenschutzModal
        isOpen={isDatenschutzOpen}
        onClose={() => setIsDatenschutzOpen(false)}
      />

      <BottomNav onScrollToCategories={scrollToCategories} />
    </div>
  );
}
